export const frontmatter = {
    "title": "Capacidades de OnnIA",
    "description": "Los módulos principales de la plataforma OnnIA: constructor de agentes, canales, ticketing, contactos, integraciones, base de conocimiento y gobernanza.",
    "sidebar_label": "Capacidades",
    "sidebar_group": "conceptos",
    "sidebar_order": 3,
    "hide_title": true,
    "toc": false
}

export const toc = [
    {
        "depth": 2,
        "id": "modulos-de-la-plataforma",
        "value": "Módulos de la plataforma"
    },
    {
        "depth": 2,
        "id": "canales-disponibles",
        "value": "Canales disponibles"
    },
    {
        "depth": 2,
        "id": "como-funciona-la-base-de-conocimiento",
        "value": "Cómo funciona la base de conocimiento"
    }
]